const LANGUAGES = {
    0: "en",
    1: "sp",
    2: "pt-BR",
    3: "it",
};

export default LANGUAGES;
